import { tS } from "../../services/translation.service";

interface IProps {
  setIsBlind: (blind: boolean) => void;
  onNextStep: () => void;
  locationName: string;
  isGerman: boolean;
  selectedLanguage: number;
  defaultLanguage: number;
}

export const ScanStep = (props: IProps) => {
  const { setIsBlind, onNextStep, locationName, isGerman, selectedLanguage, defaultLanguage } = props;

  //const [isSuccess, setSuccess] = useState(false);
  //const [locationName, setLocationName] = useState("");

  /*const getLocationByCode = (locationCode: string) => {
    locationService
      .getLocation(locationCode)
      .then((response) => {
        if (response) {
          setSuccess(true);
          setScannedLocationId(response.locationId);
          setLocationName(response.locationName);
        } else {
          setSuccess(false);
        }
      })
      .catch(() => {
        setSuccess(false);
      });
  };*/

  const onNextFlowHandler = (isBlindFlow: boolean) => {
    setIsBlind(isBlindFlow);
    onNextStep();
  };

  /*useEffect(() => {
    getLocationByCode(locationCode);
  }, []);*/

  return (
    <div className="container">
        <>
          <div className="container">
            <p>{tS.gT(tS.P.YouHaveSelectedLanguage, selectedLanguage)}</p>
            <p>{tS.gT(tS.P.TerminalsAreNamedAfter, selectedLanguage)}
              <br/> {tS.gT(tS.P.CityAndNumberedConsecutively, selectedLanguage)}{selectedLanguage != 2 ? locationName : ""}</p>
            <p>{tS.gT(tS.P.SelectBookCompartment, selectedLanguage)} </p>
            { defaultLanguage != 2 && <p>{tS.gT(tS.P.BlindVisualyImparedShould, selectedLanguage)}
              <br/>{tS.gT(tS.P.SelectBarrierFree, selectedLanguage)}</p>}
            <button
              style={{ margin: 10 }}
              onClick={() => onNextFlowHandler(false)}
            >
              {tS.gT(tS.P.BookCompartment, selectedLanguage)}
            </button>
            { defaultLanguage != 2 && <button
              style={{ margin: 10 }}
              onClick={() => onNextFlowHandler(true)}
            >
              {tS.gT(tS.P.BarrierFreeBooking, selectedLanguage)}
            </button>}
          </div>
        </>
      
    </div>
  );
};
